export default "__VITE_PUBLIC_ASSET__1ca3e27a__"